import {Button, Dialog, DialogActions, DialogContent} from "@mui/material";
import React, {ReactElement} from "react";
import {useTranslation} from "react-i18next";
// eslint-disable-next-line camelcase
import type { IAvailableUsersAvailableUsers as AvailableUser } from '../../api/generated/models';
import AddInputs from "./AddInputs";

interface Props {
    currentData: object | undefined
    onClose: () => void
    onSubmit: (val: any) => void
    control: any
    formState: any
    users: AvailableUser[]
}

const AddDialog = ({currentData, onClose, onSubmit, control, formState, users}: Props): ReactElement => {
    const {t} = useTranslation("common");

    return <Dialog
        open={currentData !== undefined}
        fullWidth
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
    >
        <form onSubmit={onSubmit}>
            <DialogContent>
                <AddInputs control={control} formS={formState} users={users} />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    {t("cancel")}
                </Button>
                <Button type="submit" color="primary">
                    {t('submit')}
                </Button>
            </DialogActions>
        </form>
    </Dialog>
}

export default AddDialog
